import type { ImageFileExtension } from '../../general';

export const ARTICLE_IMAGE_DEFAULT_MAX_BYTES = 1024 * 1024 * 5; // 5 MB
export const ARTICLE_IMAGE_EDITOR_MAX_BYTES = 1024 * 1024 * 50; // 50 MB

type UploadSizeLimits = {
    minBytes?: number;
    maxBytes?: number;
};

export type PublicArticleImageUploadUrlParams = {
    articleId: string;
    fileExtension: ImageFileExtension;
    size?: UploadSizeLimits;
    bucketName: string;
    expiresAt?: Date;
};

export type FileNameFromPublicUrlParams = {
    publicUrl: string;
    bucketName: string;
};
